import { Actions } from '../actions/billingErrors';
import {
  CLEAN_BILLING_ERROR,
  CLEAN_INSUFFICIENT_FUNDS_ERROR,
  ERROR_CATCH,
  INSUFFICIENT_FUNDS_ERROR_CATCH
} from '../constants/billingErrors';

export type State = {
  billingSystemError: Error;
  insufficientFundsError: Error;
};

type Error = {
  data: string | null;
  place: string;
};

export const initialState = {
  billingSystemError: {
    data: null,
    place: ''
  },
  insufficientFundsError: {
    data: null,
    place: ''
  }
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case ERROR_CATCH:
      return {
        ...state,
        billingSystemError: action.error
      };
    case INSUFFICIENT_FUNDS_ERROR_CATCH:
      return {
        ...state,
        insufficientFundsError: action.error
      };
    case CLEAN_BILLING_ERROR:
      return {
        ...state,
        billingSystemError: {
          data: null,
          place: ''
        }
      };
    case CLEAN_INSUFFICIENT_FUNDS_ERROR:
      return {
        ...state,
        insufficientFundsError: {
          data: null,
          place: ''
        }
      };
    default:
      return state;
  }
}
